function warnMock(enabled) {
  if (!process.client) {
    return;
  }
  if (!enabled) {
    return console.warn(`The Umami module has been disabled.
To enable, set \`enable\` to true in the module options.`);
  }
  if (process.env.NODE_ENV !== "production") {
    console.warn("Umami is not ready. Maybe there was an error loading the script or you are using it before `onMounted`.");
  }
}
export function useMock(enabled = true) {
  const trackEvent = (eventValue, eventType, url, websiteId) => warnMock(enabled);
  const trackView = (url, referer, websiteId) => warnMock(enabled);
  const umami = (eventValue) => trackEvent(eventValue);
  umami.trackView = trackView;
  umami.trackEvent = trackEvent;
  return umami;
}
export function loadScript(src, attrs) {
  const document = typeof window !== "undefined" ? window.document : void 0;
  const _attrs = attrs || {};
  let _promise = null;
  const loadScript2 = () => new Promise((resolve, reject) => {
    const resolveWithElement = (el2) => {
      resolve(el2);
      return el2;
    };
    if (!document) {
      resolve(false);
      return;
    }
    let shouldAppend = false;
    let el = document.querySelector(`script[src="${src}"]`);
    if (!el) {
      el = document.createElement("script");
      el.type = "text/javascript";
      el.async = true;
      el.defer = true;
      el.src = src;
      Object.entries(_attrs).forEach(([name, value]) => el.setAttribute(name, value.toString()));
      shouldAppend = true;
    } else if (el.hasAttribute("data-loaded")) {
      resolveWithElement(el);
    }
    el.addEventListener("error", (event) => reject(event));
    el.addEventListener("abort", (event) => reject(event));
    el.addEventListener("load", () => {
      el.setAttribute("data-loaded", "true");
      resolveWithElement(el);
    });
    if (shouldAppend) {
      el = document.head.appendChild(el);
    }
  });
  const load = () => {
    if (!_promise) {
      _promise = loadScript2();
    }
    return _promise;
  };
  return { load };
}
export function stripAttrs({ websiteId, autoTrack, cache, doNotTrack, domains, hostUrl }) {
  return {
    "data-website-id": websiteId,
    ...autoTrack !== void 0 && { "data-auto-track": autoTrack },
    ...doNotTrack !== void 0 && { "data-do-not-track": doNotTrack },
    ...cache !== void 0 && { "data-cache": cache },
    ...domains !== void 0 && { "data-domains": domains },
    ...hostUrl !== void 0 && { "data-host-url": hostUrl }
  };
}
